import { render, staticRenderFns } from "./SearchTags.vue.html?vue&type=template&id=624e2723&"
import script from "./SearchTags.component.js?vue&type=script&lang=vueJs&"
export * from "./SearchTags.component.js?vue&type=script&lang=vueJs&"
import style0 from "./SearchTags.scss?vue&type=style&index=0&prod&lang=vueScss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports